import type { StepsFilter } from "@src/gql/graphql";

export const onboardingQueryKeys = {
	all: ["onboarding"] as const,
	filter: (step: StepsFilter) => [...onboardingQueryKeys.all, step] as const,
};
